import styles from "./Burger.module.css";
import buttonStyle from "./Button.module.css";
import classNames from "classnames";
import { useState } from "react";

function Burger({ retracted, setIsMenuOpen }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsMenuOpen(!isOpen);
    setIsOpen(!isOpen);
  };
  return (
    <div
      className={classNames({
        [styles.Burger]: true,
        [buttonStyle.button]: true,
        [styles.retracted]: retracted,
      })}
      onClick={handleClick}
    >
      <div className={styles.stripeWrapper}>
        <div
          className={classNames({
            [styles.stripe]: true,
            [styles.top]: true,
            [styles.active]: isOpen,
          })}
        ></div>
        <div
          className={classNames({
            [styles.stripe]: true,
            [styles.bottom]: true,
            [styles.active]: isOpen,
          })}
        ></div>
      </div>
    </div>
  );
}

export default Burger;
